module.exports = __webpack_public_path__ + "img/last_reading_icon.37077644.png";